import React from 'react';
import {Chip} from "@material-ui/core";
import {makeStyles} from "@material-ui/core/styles";
import "./FilterSearchChip.scss";

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        justifyContent: 'left',
        flexWrap: 'wrap',
        listStyle: 'none',
        margin: 0,
    },
    chip: {
        fontWeight: "600",
        fontFamily: "MontSerrat",
        background: "#D6D2D8",
        margin: theme.spacing(1),
    },
}));

const FilterSearchChip = (props) => {

    const classes = useStyles();
    const {chipData, setChipData} = props;

    const handleDelete = (chipToDelete) => () => {
        setChipData((chips) => chips.filter((chip) => chip.key !== chipToDelete.key));
    };

    return (
        <div style={{paddingBottom: chipData.length > 0 ? "30px" : "unset"}} className={classes.root}>
            {chipData.map((data) => {
                return (
                    <li key={data.key}>
                        <Chip
                            label={`#${data.label}`}
                            onDelete={handleDelete(data)}
                            className={classes.chip}
                        />
                    </li>
                );
            })}
        </div>
    );
};

export default FilterSearchChip;
